// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__XEYFL","container":"styles_container__I6O1w","title":"styles_title__29hFN","wrapper":"styles_wrapper__3XvKq","answer":"styles_answer__2lQ_d"};